import { Component, OnInit } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { Client } from '../../../core/models/client.model';
import { ClientsService } from '../../../core/services/clients.service';
import {
  ClientConfigurationOptionsService
} from '../../../core/services/client-configuration-options.service';
import { NavigationService } from '../../../core/services/navigation.service';
import { ClientConfigurationOption } from '../../../core/models/client-configuration-option.model';

@Component({
  selector: 'app-capture-admin-client-configuration',
  templateUrl: './capture-admin-client-configuration.component.html',
  styleUrls: ['./capture-admin-client-configuration.component.scss'],
  standalone: false
})
export class CaptureAdminClientConfigurationComponent implements OnInit {
  client: Client;
  loading = false;

  clientConfigurationOptions: ClientConfigurationOption[] = [];

  constructor(
    private clientsService: ClientsService,
    private clientConfigurationOptionsService: ClientConfigurationOptionsService,
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    const clientId = this.navigationService.currentId;
    this.loadConfigs(clientId);
  }

  private loadConfigs(clientId): void {
    this.loading = true;

    this.clientsService.get(clientId).pipe(
      mergeMap((client: Client) => {
        this.client = client;
        return this.clientConfigurationOptionsService.getList(this.client.id);
      })
    ).subscribe(({ clientConfigurationOptions }) => {
      this.clientConfigurationOptions = clientConfigurationOptions;
      this.loading = false;
    });

  }
}
